
import { BASE_URL } from '../../config';
import {
    OPEN_DISPATCH_CONFIG_MODAL, 
    CLOSE_DISPATCH_CONFIG_MODAL, 
    DISPATCH_CONFIG_CREATED, DISPATCH_CONFIG_UPDATED, 
    GET_DISPATCH_CONFIG_LIST, 
    DISPATCH_CONFIG_SET_ACTIVE, 
    DISPATCH_CONFIG_DELETE 
} from './dispatch.actionsTypes'

import axios from 'axios';
import Notifier from '../../components/message/Notifier';
import { loadingAction } from '../../components/loading/loading.action';

export const getDispatchConfigList = (callback = ()=>{}) => {
    return loadingAction((dispatch, cb) => {
        axios.get(`${BASE_URL}dispatch/configs`)
        .then((response) => {
            dispatch({
                type: GET_DISPATCH_CONFIG_LIST,
                areaList: response.data
            });
            callback(null,response.data);
        })
        .catch((err) => {
            callback(err,null)
        })
        .finally(() => {
            cb()
        })
    });
};

export const openDispatchModal = (selectedDispatch = null) => {
    return {
        type: OPEN_DISPATCH_CONFIG_MODAL,
        selectedDispatch
    };
};

export const closeDispatchModal = () => {
    return {
        type: CLOSE_DISPATCH_CONFIG_MODAL
    };
};

const dispatchConfigCreated = (config) => {
    return {
        type: DISPATCH_CONFIG_CREATED,
        config
    };
}
const dispatchConfigUpdated = (config, id) => {
    return {
        type: DISPATCH_CONFIG_UPDATED,
        config,
        id
    };
};

export const createDispatchConfigByAPI = (data, cb) => {
    return (dispatch) => {
        axios.post(`${BASE_URL}dispatch/config`, data)
            .then((response) => {
                if (response.data) {
                    dispatch(dispatchConfigCreated(response.data));
                    Notifier.success('_config_successfully_updated_', '_config_created_');
                    cb(response.data);
                }
            });
    };
};

export const updateDispatchConfigByAPI = (id, data, cb) => {
    return (dispatch) => {
        axios.put(`${BASE_URL}dispatch/config/${id}`, data)
            .then((response) => {
                if (response.data) {
                    dispatch(dispatchConfigUpdated(response.data, id));
                    Notifier.success('_config_successfully_updated_', '_config_updated_');
                    cb(response.data);
                }
            });
    };
};

export const activateConfig = (id,cb=()=>{}) => {
    return (dispatch) => {
        axios.post(`${BASE_URL}dispatch/config/${id}/active`)
            .then((response) => {
                if (response.data) {
                    dispatch({
                        type: DISPATCH_CONFIG_SET_ACTIVE,
                        id
                    })
                    Notifier.success('_config_successfully_updated_', '_config_updated_');
                    cb(response.data);
                }
            });
    };
};

export const deleteConfig = (id,cb=()=>{}) => {
    return (dispatch) => {
        axios.delete(`${BASE_URL}dispatch/config/${id}`)
            .then((response) => {
                if (response.data) {
                    dispatch({
                        type: DISPATCH_CONFIG_DELETE,
                        id
                    })
                    Notifier.success('_config_successfully_updated_', '_config_updated_');
                    cb(response.data);
                }
            });
    };
};